import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';

let BASE_URL = '';
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrfmiddlewaretoken";

if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    BASE_URL = 'https://dev.cocoonsealy.net';
}else if (window.location.hostname === 'dev.cocoonsealy.net'){
    BASE_URL = 'https://dev.cocoonsealy.net';
}else if (window.location.hostname === 'staging.cocoonbysealy.ca'){
    BASE_URL = 'https://staging.cocoonbysealy.ca';
}else if (window.location.hostname === 'cocoonbysealy.ca') {
    BASE_URL = 'https://cocoonbysealy.ca';
}

// console.log(`(repository) window location is: `, window.location.hostname);

let config = {
  headers: {'Access-Control-Allow-Origin': '*'},
  // proxy: {
	//   host: 'http://dev.cocoonsealy.net',
	//   port: 80
	// }
};
// axios.get('https://a.4cdn.org/' + board + '/threads.json', config)
//   .then(function (response) {
//       console.log(response.data);
// });

export function getProducts() {        
    let res = '';
    return axios.get(`${BASE_URL}/api/products/`)

            .then(response => {
              res=response.data;
              const results = res.filter(item => item.upc === '')
              return results;
            });

}

export function getChildProducts(url) {        
  
  return axios.get(url)

            .then(response => response.data);            
}

function productDetail (url, category, parent_id) {

  
}

export function getCartProducts() {

    return axios.get(`${BASE_URL}/api/basket/`)

            .then(response => response.data);

}

export function fetchData(url) {
  // console.log(`Fetch ${url}`);
  return axios.get(url)

            .then(response => response.data);
}

export function fetchDataTitle(url) {
  // console.log(`Fetch ${url}`);
  return axios.get(url)

            .then(response => response.data.title);
}

export function getOptions() {

    return axios.get(`${BASE_URL}/api/options/`)

            .then(response => response.data);

}

export function getShippingMethods() {

    return axios.get(`${BASE_URL}/api/basket/shipping-methods/`)

            .then(response => response.data);

}

export function getOffers() {

  return axios.get(`${BASE_URL}/api/checkout/cbsoffers/`)

          .then(response => response.data);

}

export function get_user_lang() {

  return axios.get(`${BASE_URL}/api/checkout/userlang/`)

          .then(response => response.data);

}

export function addProduct(product_data, csrftoken) {

    let sendheaders = {}
    const url = `${BASE_URL}/api/basket/add-product/`;
    // console.log(`Inside Adding Product Function`);
    // console.log(product_data);
    if (!csrfSafeMethod('POST') && sameOrigin(url)) {
      //console.log(`pass test + csrftoken: ${csrftoken}`);      
       sendheaders = {
        
      };

      config = {
        headers: {
        // 'Access-Control-Allow-Origin': '*',        
        'HTTP_X_CSRFTOKEN': csrftoken,
        // 'X_CSRFTOKEN': csrftoken,
        'Content-type': 'application/json',
        'method': 'OPTIONS'
        }
      };
        
    } else {
      config = {        
        proxy: {
          host: '127.0.0.1',
          port: 8001
        },
        header:{          
            'Content-type': 'application/json',
            
        }
      }
    }
    // console.log(`headers sent`, config)
    // { "url": "http://testserver.org/oscarapi/products/209/", "quantity": 6, "options": [{ "option": "http://testserver.org/oscarapi/options/1/", "value": "some value" }] }
    return axios
      .post(
        url,
        product_data,
        config
      )
      .then( response => response.data )
      .catch(err => {            
            
            // Promise.reject(err)
            Promise.reject('Adding product to cart Failed!')
        }
      ).then( (data) => {
        return data;
      });

}

export function guest_email(email, csrftoken, userlang) {

  let sendheaders = {}
  let url; 
  if (userlang === 'fr')
    url = `${BASE_URL}/fr/store/checkout/user-signon/`;  
  else
    url = `${BASE_URL}/en/store/checkout/user-signon/`;  

  if (!csrfSafeMethod('POST') && sameOrigin(url)) {
    //console.log(`pass test + csrftoken: ${csrftoken}`);      
     sendheaders = {
      
    };

    config = {
      headers: {'Access-Control-Allow-Origin': '*'},        
      'HTTP_X_CSRFTOKEN': csrftoken,
      'Content-type': 'application/json',
      'method': 'OPTIONS'
    }
      
  } else {
    config = {        
      proxy: {
        host: '127.0.0.1',
        port: 8001
      },
      header:{          
          'Content-type': 'application/json',
          
      }
    }
  }
  // { "url": "http://testserver.org/oscarapi/products/209/", "quantity": 6, "options": [{ "option": "http://testserver.org/oscarapi/options/1/", "value": "some value" }] }
  return axios
    .post(
      url,
      email,
      config
    )
    .then( response => response.data )
    .catch(err => {            
          
          // Promise.reject(err)
          Promise.reject('Setting shipping address session failed')
      }
    ).then( (data) => {
      return data;
    });

}

export function shipping_methods(methods, csrftoken, userlang) {

  let sendheaders = {}

  let url; 
  if (userlang === 'fr')
    url = `${BASE_URL}/fr/store/checkout/shipping-methods/`;    
  else
    url = `${BASE_URL}/en/store/checkout/shipping-methods/`;    

  if (!csrfSafeMethod('POST') && sameOrigin(url)) {
    //console.log(`pass test + csrftoken: ${csrftoken}`);      
     sendheaders = {
      
    };

    config = {
      headers: {'Access-Control-Allow-Origin': '*',        
      'HTTP_X_CSRFTOKEN': csrftoken,
      'Content-type': 'application/json',
      'method': 'OPTIONS'
      }
    }
      
  } else {
    config = {        
      proxy: {
        host: '127.0.0.1',
        port: 8001
      },
      header:{          
          'Content-type': 'application/json',
          
      }
    }
  }
  // { "url": "http://testserver.org/oscarapi/products/209/", "quantity": 6, "options": [{ "option": "http://testserver.org/oscarapi/options/1/", "value": "some value" }] }
  return axios
    .post(
      url,
      methods,
      config
    )
    .then( response => response.data )
    .catch(err => {            
          
          // Promise.reject(err)
          Promise.reject('Setting shipping address session failed')
      }
    ).then( (data) => {
      return data;
    });

}

export function get_shipping_method(method, csrftoken, userlang) {

  let sendheaders = {}
  let url; 
  if (userlang === 'fr')
    url = `${BASE_URL}/fr/store/checkout/shipping-method/`;    
  else
    url = `${BASE_URL}/en/store/checkout/shipping-method/`;
  if (!csrfSafeMethod('POST') && sameOrigin(url)) {
    //console.log(`pass test + csrftoken: ${csrftoken}`);      
     sendheaders = {
      
    };

    config = {
      headers: {'Access-Control-Allow-Origin': '*'},        
      // 'X-CSRFToken': csrftoken,
      'Content-type': 'application/json',
      'method': 'OPTIONS'
    }
      
  } else {
    config = {        
      proxy: {
        host: '127.0.0.1',
        port: 8001
      },
      header:{          
          'Content-type': 'application/json',
          
      }
    }
  }
  // { "url": "http://testserver.org/oscarapi/products/209/", "quantity": 6, "options": [{ "option": "http://testserver.org/oscarapi/options/1/", "value": "some value" }] }
  return axios
    .get(url)
    .then( response => response.data )
    .catch(err => {            
          
          // Promise.reject(err)
          Promise.reject('Setting shipping address session failed')
      }
    ).then( (data) => {
      return data;
    });

}

export function tax_calc(data, csrftoken) {

  let sendheaders = {}
  const url = `${BASE_URL}/api/checkout/tax-calc/`;    
  if (!csrfSafeMethod('POST') && sameOrigin(url)) {
    //console.log(`pass test + csrftoken: ${csrftoken}`);      
     sendheaders = {
      
    };

    config = {
      headers: {'Access-Control-Allow-Origin': '*',        
      'HTTP_X_CSRFTOKEN': csrftoken,
      'Content-type': 'application/json',
      'method': 'OPTIONS'
      }
    }
      
  } else {
    config = {        
      proxy: {
        host: '127.0.0.1',
        port: 8001
      },
      header:{          
          'Content-type': 'application/json',
          
      }
    }
  }
  // { "url": "http://testserver.org/oscarapi/products/209/", "quantity": 6, "options": [{ "option": "http://testserver.org/oscarapi/options/1/", "value": "some value" }] }
  return axios
    .post(
      url,
      data,
      config
    )
    .then( response => response.data )
    .catch(err => {            
          
          // Promise.reject(err)
          Promise.reject('Setting shipping address session failed')
      }
    ).then( (data) => {
      return data;
    });

}

export function shipping_Address(address, csrftoken, userlang ) {

  let sendheaders = {}
  // const url = `${BASE_URL}/api/checkout/shipping-address/`;  
  let url; 
  if (userlang === 'fr')
    url = `${BASE_URL}/fr/store/checkout/shipping-address/`;  
  else
    url = `${BASE_URL}/en/store/checkout/shipping-address/`;
  // console.log(address);
  if (!csrfSafeMethod('POST') && sameOrigin(url)) {
    //console.log(`pass test + csrftoken: ${csrftoken}`);      
     sendheaders = {
      
    };

    config = {
      headers: {'Access-Control-Allow-Origin': '*',        
      'HTTP_X_CSRFTOKEN': csrftoken,
      'Content-type': 'application/json',
      'method': 'OPTIONS'
      }
    }
      
  } else {
    config = {        
      proxy: {
        host: '127.0.0.1',
        port: 8001
      },
      header:{          
          'Content-type': 'application/json',
          
      }
    }
  }
  // { "url": "http://testserver.org/oscarapi/products/209/", "quantity": 6, "options": [{ "option": "http://testserver.org/oscarapi/options/1/", "value": "some value" }] }
  return axios
    .post(
      url,
      address,
      config
    )
    .then( response => response.data )
    .catch(err => {            
          
          // Promise.reject(err)
          Promise.reject('Setting shipping address session failed')
      }
    ).then( (data) => {
      return data;
    });

}

export function billing_Address(address, csrftoken, userlang) {

  let sendheaders = {}
  let url; 
  if (userlang === 'fr')
    url = `${BASE_URL}/fr/store/checkout/billing-address/`;  
  else
    url = `${BASE_URL}/en/store/checkout/billing-address/`;  

  // console.log(address);
  if (!csrfSafeMethod('POST') && sameOrigin(url)) {
    //console.log(`pass test + csrftoken: ${csrftoken}`);      
     sendheaders = {
      
    };

    config = {
      headers: {'Access-Control-Allow-Origin': '*',        
      'HTTP_X_CSRFTOKEN': csrftoken,
      'Content-type': 'application/json',
      'method': 'OPTIONS'
      }
    }
      
  } else {
    config = {        
      proxy: {
        host: '127.0.0.1',
        port: 8001
      },
      header:{          
          'Content-type': 'application/json',
          
      }
    }
  }
  // { "url": "http://testserver.org/oscarapi/products/209/", "quantity": 6, "options": [{ "option": "http://testserver.org/oscarapi/options/1/", "value": "some value" }] }
  return axios
    .post(
      url,
      address,
      config
    )
    .then( response => response.data )
    .catch(err => {            
          
          // Promise.reject(err)
          Promise.reject('Setting billing address session failed')
      }
    ).then( (data) => {
      return data;
    });

}

export function addressvalidation(data, csrftoken){
  let url; 
  url = `${BASE_URL}/api/checkout/address-validation/`;  
    
  if (!csrfSafeMethod('POST') && sameOrigin(url)) {    

    config = {
      headers: {'Access-Control-Allow-Origin': '*',        
      'HTTP_X_CSRFTOKEN': csrftoken,
      'Content-type': 'application/json',
      'method': 'OPTIONS'
      }
    }
      
  } else {
    config = {        
      proxy: {
        host: '127.0.0.1',
        port: 8001
      },
      header:{          
          'Content-type': 'application/json',
          
      }
    }
  }
  return axios
    .post(
      url,
      data,
      config
    )
    .then( response => response.data )
    .catch(err => {            
          
          // Promise.reject(err)
          Promise.reject(err.response)          
          Promise.reject('FedEx API address validation failed', err.response)                  
          return  err.response.data
      }
    );
}

export function userlogin(username, password, csrftoken) {

  let sendheaders = {}
  const url = `http://dev.cocoonsealy.net/api/login/`;
  // console.log(`Inside user login Function`);
  // console.log(product_data);
  if (!csrfSafeMethod('POST') && sameOrigin(url)) {
    //console.log(`pass test + csrftoken: ${csrftoken}`);      
     sendheaders = {
      
    };

    config = {
      headers: {'Access-Control-Allow-Origin': '*'},        
      'HTTP_X_CSRFTOKEN': csrftoken,
      'Content-type': 'application/json',
      'method': 'OPTIONS'
    }
      
  } else {
    config = {        
      proxy: {
        host: 'http://dev.cocoonsealy.net',
        port: 80
      },
      header:{          
          'Content-type': 'application/json',   
          'withCredentials': true       
      }
    }
  }  
  return axios
    .post(
      url,
      {
        username: username,
        password: password
      },
      config
    )
    .then( response => response.data )
    .catch(err => {            
          // console.log(`+++++++++++++++++++++++++++++++++++ LOGIN ERROR ++++++++++++++++++++++++`, err);
          // Promise.reject(err)
          Promise.reject('Login Failed!')
      }
    ).then( (data) => {
      return data;
    });

}

export function updateProductQuantity(data, csrftoken) {

    let sendheaders = {}    

    if (!csrfSafeMethod('PUT') && sameOrigin(data.url)) {
      //console.log(`pass test + csrftoken: ${csrftoken}`);      
       sendheaders = {
        'X-CSRFToken': csrftoken,
        'Content-type': 'application/json',
      };
    } else {
      sendheaders = {};
    }
    // { "url": "http://testserver.org/oscarapi/products/209/", "quantity": 6, "options": [{ "option": "http://testserver.org/oscarapi/options/1/", "value": "some value" }] }
    return axios
      .put(
        data.url,
        {          
          quantity: data.quantity,
          "product":data.product,
          "basket":data.basket,
          "stockrecord":data.stockrecord
        },
        {headers: sendheaders}
      )
      .then( response => response.data )
      .catch(err => {            
            
            Promise.reject(err)
            Promise.reject('Updating product quantity Failed!')
        }
      );

}

export function removeProduct(data, csrftoken) {

    let sendheaders = {}    

    if (!csrfSafeMethod('POST') && sameOrigin(data.url)) {
      //console.log(`pass test + csrftoken: ${csrftoken}`);      
       sendheaders = {
        'X-CSRFToken': csrftoken,
        'Content-type': 'application/json',
      };
    } else {
      sendheaders = {};
    }
    // { "url": "http://testserver.org/oscarapi/products/209/", "quantity": 6, "options": [{ "option": "http://testserver.org/oscarapi/options/1/", "value": "some value" }] }
    return axios
      .delete(
        data.url,
        {          
          quantity: data.quantity,          
        },
        {headers: sendheaders}
      )
      .then( response => response.data )
      .catch(err => {            
            
            Promise.reject(err)
            Promise.reject('Removing product to cart Failed!')
        }
      );

}

export function addPromocode(code, csrftoken) {

  let sendheaders = {}    
  const url = `${BASE_URL}/api/basket/add-voucher/`;

  if (!csrfSafeMethod('POST') && sameOrigin(url)) {
    //console.log(`pass test + csrftoken: ${csrftoken}`);      
     sendheaders = {
      'X-CSRFToken': csrftoken,
      'Content-type': 'application/json',
    };
  } else {
    sendheaders = {};
  }
  // { "url": "http://testserver.org/oscarapi/products/209/", "quantity": 6, "options": [{ "option": "http://testserver.org/oscarapi/options/1/", "value": "some value" }] }
  return axios
    .post(
      url,
      {          
        "vouchercode": code,
      },
      {headers: sendheaders}
    )
    .then( response => response.data )
    .catch( (err) => {            
          
        
          Promise.reject(err.response)
          Promise.reject('Adding promo code to cart Failed!')      
          return  err.response.data
      }
    )    

}

export function cart_quantity(contents) {
    // get current basket
    const basket = getCartProducts();
    // get lines from current basket
    axios.get(basket.lines)

        .then(response => {
                let quantity = 0;
                let i =0;
                for (i=0; i < response.data.length; i++) {
                    quantity = quantity + response.data.quantity[i];
                }
                return quantity;
            
            }                
        );

}

export function load_mini_basket()  {
    const basket = getCartProducts();
    // get lines from current basket
    axios.get(basket.lines)

        .then( response => response.data );        
}

export function sanity_check(url)  {
  console.log("Ok Here we go")  
  fetchData(url)

}

export function filterProducts(products, category, matsize, comfort) {
  // search by size and category, comfort
  let i=0;
  let catmatch = "";
  let tmatch = "";
  console.log(`Filtering Products: ${products}`)
  console.log(`Inside filter products => Category: ${category}, Comfort: ${comfort}, Size: ${matsize}`);
  for (let [key, value] of Object.entries(products)) {
    // console.log(`${key}: ${value}`);       
    // console.log(value.title.match(/Twin/g));
    if (category === 'cocoon-essential') {
      console.log(`Essential mattress`);
      console.log(`${value.title}: ${value.category}`); 
      if (comfort === 'Medium' && value.title.match(/Medium/g)) {

        if ( value.title.match(/Medium/g) && value.title.match(/King/g) && value.category.match(/cocoon-essential/g) && matsize === 'King'  ) {
          console.log( `Picke Me ${value.title}`)
          return value;
        }else if ( value.title.match(/Medium/g) && value.title.match(/Twin/g) && value.category.match(/cocoon-essential/g) && matsize === 'Twin' ) {
          console.log( `Picke Me ${value.title}`)
          return value;
        }else if ( value.title.match(/Medium/g) && value.title.match(/XL/g) && value.category.match(/cocoon-essential/g) && matsize === 'Twin XL' ) {
          console.log( `Picke Me ${value.title}`)
          return value;
        }else if ( value.title.match(/Medium/g) && value.title.match(/Full/g) && value.category.match(/cocoon-essential/g) && matsize === 'Full' ) {
          console.log( `Picke Me ${value.title}`)
          return value;
        }else if ( value.title.match(/Medium/g) && value.title.match(/Queen/g )  && value.category.match(/cocoon-essential/g) && matsize === 'Queen' ) {
          console.log( `Picke Me ${value.title}`)
          return value;
        }

      }      
    }else{
      console.log(`Classic mattress`);
      console.log(`${value.title}: ${value.category}`); 
      if (comfort === 'Soft' && value.title.match(/Soft/g)) {
        if ( value.title.match(/King/g) && value.title.match(/Soft/g) && value.category.match(/cocoon-classic/g ) && matsize === 'King') {
          console.log( `Picke Me ${value.title}`)
          return value;
        }else if ( value.title.match(/Soft/g) && value.title.match(/Twin/g) && value.category.match(/cocoon-classic/g)  && matsize === 'Twin' ) {
          console.log( `Picke Me ${value.title}`)
          return value;
        }else if ( value.title.match(/Soft/g) && value.title.match(/XL/g) && value.category.match(/cocoon-classic/g)  && matsize === 'Twin XL' ) {
          console.log( `Picke Me ${value.title}`)
          return value;
        }else if ( value.title.match(/Soft/g) && value.title.match(/Full/g) && value.category.match(/cocoon-classic/g)  && matsize === 'Full' ) {
          console.log( `Picke Me ${value.title}`)
          return value;
        }else if ( value.title.match(/Soft/g) && value.title.match(/Queen/g )  && value.category.match(/cocoon-classic/g)  && matsize === 'Queen' ) {
          console.log( `Picke Me ${value.title}`)
          return value;   
        }    
      }else{
        if ( value.title.match(/Firm/g) && value.title.match(/King/g) && value.category.match(/cocoon-classic/g ) && matsize === 'King') {
          console.log( `Picke Me ${value.title}`)
          return value;
        }else if ( value.title.match(/Firm/g) && value.title.match(/Twin/g) && value.category.match(/cocoon-classic/g)  && matsize === 'Twin' ) {
          console.log( `Picke Me ${value.title}`)
          return value;
        }else if ( value.title.match(/Firm/g) && value.title.match(/XL/g) && value.category.match(/cocoon-classic/g)  && matsize === 'Twin XL' ) {
          console.log( `Picke Me ${value.title}`)
          return value;
        }else if ( value.title.match(/Firm/g) && value.title.match(/Full/g) && value.category.match(/cocoon-classic/g)  && matsize === 'Full' ) {
          console.log( `Picke Me ${value.title}`)
          return value;
        }else if ( value.title.match(/Firm/g) && value.title.match(/Queen/g )  && value.category.match(/cocoon-classic/g)  && matsize === 'Queen' ) {
          console.log( `Picke Me ${value.title}`)
          return value;   
        }
      }
    } 
  }       
}

function csrfSafeMethod(method) {
    // these HTTP methods do not require CSRF protection
    // return /^(GET|HEAD|OPTIONS|POST|TRACE)$/.test(method);
    return /^(GET|HEAD|TRACE)$/.test(method);
}

function sameOrigin(url) {
    // test that a given url is a same-origin URL
    // url could be relative or scheme relative or absolute
    const host = document.location.host; // host + port
    const protocol = document.location.protocol;
    const sr_origin = `//${host}`;
    const origin = protocol + sr_origin;
    // Allow absolute or scheme relative URLs to same origin
    return (
      url === origin ||
      url.slice(0, origin.length + 1) === `${origin}/` ||
      (url === sr_origin ||
        url.slice(0, sr_origin.length + 1) === `${sr_origin}/`) ||
      // or any other URL that isn't scheme relative or absolute i.e relative.
      !/^(\/\/|http:|https:).*/.test(url)
    );
}